export default __webpack_public_path__ + "static/media/dinnerandashow300.313d5540.jpg";